<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Materi</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Materi</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tabmateri" data-toggle="tab">Materi</a>                                                
											</li> 

											<!-- <li class="nav-item">
												<a class="nav-link" href="#tabkategori" data-toggle="tab">Kategori</a>                                                
											</li> 
                                             
											<li class="nav-item">
												<a class="nav-link" href="#tabsubject" data-toggle="tab"><span class="med-records">Subject</span></a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tabmateri" class="tab-pane fade show active">
											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdlMateri" @click="resetVarMateri(null)">Tambah Materi</a>
                                                    </div>
													<div class="table-responsive">
                                                        <table id="tblMateri" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Kategori</th>
                                                                    <th class="text-left">Subject</th>
                                                                    <th class="text-left">Judul</th>
                                                                    <th class="text-left">Publish</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstsubdtlmateri" :key="ref.id_judul">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_tingkatan }} - {{ ref.nama_materi }}</td>
                                                                    <td>{{ ref.nama_sub_materi }}</td>
                                                                    <td>{{ ref.nama_judul }}</td>
                                                                    <td>
                                                                        <span v-if="ref.fg_publish">Aktif</span>
                                                                        <span v-if="!ref.fg_publish">Tidak Aktif</span>
                                                                    </td>
                                                                    <td>
                                                                        <!-- <v-btn class="btn btn-sm bg-info-light" depressed small @click="getDetailMateri(ref)">
                                                                            <i class="fas fa-eye"></i> Detail
                                                                        </v-btn> -->
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEditMateri(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDeleteMateri(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Materi Tab -->
										
										<!-- Kategori Tab -->
										<!-- <div id="tabkategori" class="tab-pane fade show">
											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdl">Tambah Data</a>
                                                    </div>
													<div class="table-responsive">
                                                        <table id="tbl" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Materi</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstmateri" :key="ref.id_materi">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_materi }}</td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEdit(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDelete(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div> -->
                                        <!-- /Kategori Tab -->
										
										<!-- Subject Tab -->
										<!-- <div id="tabsubject" class="tab-pane fade show ">
											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdlSub">Tambah Data</a>
                                                    </div>
													<div class="table-responsive">
                                                        <table id="tblSub" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Materi</th>
                                                                    <th class="text-left">Sub Materi</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstsubmateri" :key="ref.id_sub_materi">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_materi }}</td>
                                                                    <td>{{ ref.nama_sub_materi }}</td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEditSub(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDeleteSub(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div> -->
                                        <!-- /Subject Tab -->
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <div id="addMdlMateri" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form id="frm">                            
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Judul</label>
                                        <input class="form-control" type="text" v-model="subdtlmateri.nama_judul">
                                    </div>
                                </div>
                                <!-- <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Tanggal</label>
                                        <input class="form-control" type="date" v-model="subdtlmateri.tanggal_materi">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama Coach</label>
                                        <input class="form-control" type="text" v-model="subdtlmateri.nama_coach">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Tipe Coach</label>
                                        <v-select
                                        :options="lsttypecoach"
                                        :reduce="lsttypecoach => lsttypecoach.id" 
                                        label="text"
                                        v-model="subdtlmateri.tipe_coach"
                                        />
                                    </div>
                                </div> -->
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Kategori</label>
                                        <v-select
                                        :options="lstmateri"
                                        :reduce="lstmateri => lstmateri.id_materi" 
                                        label="optmateri"
                                        v-model="subdtlmateri.kategori"
                                        @input="filterSubject"
                                        />
                                        
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Subject</label>                                      
                                        <v-select
                                        :options="lstsubject"
                                        :reduce="lstsubject => lstsubject.id_sub_materi" 
                                        label="nama_sub_materi"
                                        v-model="subdtlmateri.subject"
                                        />
                                    </div>
                                </div>
                                
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Youtube ID</label>
                                        <input class="form-control" type="text" v-model="subdtlmateri.youtube_id">
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link File</label>
                                        <input class="form-control" type="text" v-model="subdtlmateri.url_file">
                                    </div>
                                </div>
                                
                                
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Status Publish </label>
                                        <v-select
                                        :options="lststspublish"
                                        :reduce="lststspublish => lststspublish.id" 
                                        label="text"
                                        v-model="subdtlmateri.fg_publish"
                                        />
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                <hr>
                                <div class="comp-header"><h3 class="comp-title">Materi</h3> <div class="line"></div></div>
                                    <textarea class="form-control" rows="10" v-model="subdtlmateri.materi_preview"></textarea>
                                        <!-- <input name=image type=file id="upload" onchange="" class="hidden">
                                        <tinymce
                                            api-key="9fadqwhnobewr1vrn5r7wcwywh6g4acyftptdbl72sv99gnh"
                                            :init="myInit"
                                            v-model="subdtlmateri.materi_preview"
                                            /> -->
                                </div>
                            </div>
                            
                            <!-- <div class="form-group">
                                <label>Judul <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="subdtlmateri.nama_judul">
                            </div> -->
                            
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="submit-section text-center">
                            <button class="btn btn-primary submit-btn" @click.prevent="saveMateri">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="delMdlMateri" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus materi <b>{{ subdtlmateri.nama_judul }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapusMateri">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- ---------- -->
        <!-- <div id="addMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Pilih Tingkatan <span class="text-danger">*</span></label>
                                <v-select
                                :options="lsttingkatan"
                                :reduce="lsttingkatan => lsttingkatan.id_tingkatan" 
                                label="nama_tingkatan"
                                v-model="materi.id_tingkatan"
                                />                              
                            </div>
                            <div class="form-group">
                                <label>Nama Materi <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="materi.nama_materi">
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="save">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus materi <b>{{ materi.nama_materi }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- ---------- -->
        <!-- <div id="addMdlSub" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Sub Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Pilih Materi <span class="text-danger">*</span></label>
                                <v-select
                                :options="lstmateri"
                                :reduce="lstmateri => lstmateri.id_materi" 
                                label="nama_materi"
                                v-model="submateri.id_materi"
                                />                              
                            </div>
                            <div class="form-group">
                                <label>Nama Sub Materi <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="submateri.nama_sub_materi">
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="saveSub">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div id="delMdlSub" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Sub Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus Sub Materi <b>{{ submateri.nama_sub_materi }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapusSub">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import axiosTiny from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';
// import moment from "moment";

export default {
    components: {
        Sidebar
    },
	name: 'Materi',
    data() {
        return {
            lstsubdtlmateri: [],
            lstsubject: [],
            subdtlmateri: {
                id_judul: '',
                nama_judul: '',
                // hak_akses: '',
                tanggal_materi: '',
                kategori: '',
                subject: '',
                tipe_coach: '',
                nama_coach: '',
                youtube_id: '',
                url_file: '',
                fg_publish:'',
                materi_preview:''
            },
            lstmateri: [],
            // materi:{
            //     id_materi: '',
            //     nama_materi: '',
            // },
            lstsubmateri: [],
            // submateri: {
            //     id_sub_materi: '',
            //     id_materi: '',
            //     nama_sub_materi: '',
            // },
            lsttypecoach: [
                {id: '1', text: 'Master Coach'},
                {id: '2', text: 'Super Coach'},
                {id: '3', text: 'Coach'},
                {id: '4', text: 'Siswa'},
            ],
            lststspublish: [
                {id: '1', text: 'Aktif'},
                {id: '0', text: 'Tidak Aktif'}
            ],
            myInit: {
                height: 500,
                entity_encoding : 'raw',  
                paste_data_images: true,
                plugins: [
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                    'searchreplace wordcount visualblocks visualchars code fullscreen',
                    'insertdatetime media nonbreaking save table contextmenu directionality',
                    'emoticons template paste textcolor colorpicker textpattern'
                ],
                toolbar1: 'insertfile undo redo | formatselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                toolbar2: 'print preview media | forecolor backcolor emoticons tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
                external_plugins: {
                    tiny_mce_wiris: 'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js'
                    // 'tiny_mce_wiris': 'node_modules/@wiris/mathtype-tinymce4/plugin.min.js',
                },
                image_advtab: true,
                file_picker_callback: function(callback, value, meta) {
                    if (meta.filetype == 'image') {
                    $('#upload').trigger('click');
                    $('#upload').on('change', function() {
                        var file = this.files[0];
                        var reader = new FileReader();
                        reader.onload = function(e) {
                        callback(e.target.result, {
                            alt: ''
                        });
                        };
                        reader.readAsDataURL(file);
                    });
                    }
                },
                images_upload_handler: function(blobInfo, success, failure) {
                    let formreq = new FormData()
                    console.log("ini blobnya: ");
                    console.log(blobInfo.blob());
                    formreq.append('file', blobInfo.blob());
                    var instance = axiosTiny.create({ baseURL: 'https://api.pejuangpendidik.com/' });
                    instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                    instance.post('api/uploadimg', formreq,
                        {
                            // headers: {
                            //     'Content-Type': 'multipart/form-data',
                            // },
                            transformRequest: (data, headers) => {
                                return formreq;
                            },
                        }) //this.$route.params.id)
                        .then(res => {
                            console.log(res.data.location);
                            if(res.status ==200){
                                if(res.data.location !=""){
                                    success(res.data.location);
                                } else {
                                    failure('gagal upload image'+ res.data.location);
                                }
                            } else {
                                failure('gagal upload image'+ res.data.location);
                            }
                        })
                        .catch(err => {
                            // handle error
                            console.log(err);
                        })
                },
                

            },
        }
    },
    created: function () {
        this.getAllMateri();
        this.getAll();
        this.getAllSub();
    },  

    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },


        //--------------------------
        // Get Materi
        getAllMateri: function () {
            axios.get('api/subdtlmateri')
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblMateri");
                    this.lstsubdtlmateri = res.data.data;
                    this.initDt("tblMateri");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New Materi
        saveMateri: function () {
            axios.post('api/subdtlmateri', {
                    id_judul: this.subdtlmateri.id_judul,
                    nama_judul: this.subdtlmateri.nama_judul,
                    // hak_akses: this.subdtlmateri.hak_akses,
                    // tanggal_materi: this.subdtlmateri.tanggal_materi,
                    kategori: this.subdtlmateri.kategori,
                    subject: this.subdtlmateri.subject,
                    // tipe_coach: this.subdtlmateri.tipe_coach,
                    // nama_coach: this.subdtlmateri.nama_coach,
                    youtube_id: this.subdtlmateri.youtube_id,
                    url_file: this.subdtlmateri.url_file,
                    fg_publish: this.subdtlmateri.fg_publish,
                    materi_preview: this.subdtlmateri.materi_preview
                })
                .then(res => {
                    // handle success
                    this.getAllMateri();
                    this.resetVarMateri(null);
                    $("#addMdlMateri").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        filterSubject: function(value){
            // console.log("val : " + value);
            this.subdtlmateri.subject = '';
            this.lstsubject = value? this.lstsubmateri.filter(c => c.id_materi == value) : this.lstsubmateri;
        },

        resetVarMateri: function(ref,isDasabled=false){
            // console.log(ref.tanggal_materi);
            if(ref){                
                this.subdtlmateri.id_judul = ref.id_judul;
                this.subdtlmateri.nama_judul = ref.nama_judul;
                // this.subdtlmateri.hak_akses = ref.hak_akses;
                
                // let current_datetime = new Date()
                // let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear()
                // console.log(formatted_date)

                // this.subdtlmateri.tanggal_materi = new Date(ref.tanggal_materi).toISOString().split('T')[0];
                this.subdtlmateri.kategori = ref.kategori;
                this.subdtlmateri.subject = ref.subject;
                this.subdtlmateri.tipe_coach = ref.tipe_coach;
                this.subdtlmateri.nama_coach = ref.nama_coach;
                this.subdtlmateri.youtube_id = ref.youtube_id;
                this.subdtlmateri.url_file = ref.url_file;
                this.subdtlmateri.fg_publish = ref.fg_publish;
                this.subdtlmateri.materi_preview = ref.materi_preview;
            } else {
                this.subdtlmateri.id_judul = '';
                this.subdtlmateri.nama_judul = '';
                // this.subdtlmateri.hak_akses = '';
                this.subdtlmateri.tanggal_materi = '';
                this.subdtlmateri.kategori = '';
                this.subdtlmateri.subject = '';
                this.subdtlmateri.tipe_coach = '';
                this.subdtlmateri.nama_coach = '';
                this.subdtlmateri.youtube_id = '';
                this.subdtlmateri.url_file = '';
                this.subdtlmateri.fg_publish = '';
                this.subdtlmateri.materi_preview = '';
            }
            
            $("#frm input").prop("disabled", isDasabled);
            $("#frm v-select").prop("disabled", isDasabled);
        },

        // Get Detail and Show data to Modal
        getDetailMateri: function (ref) {
            this.resetVarMateri(ref, true);
            $("#addMdlMateri").modal('show');
        },
 
        // Get Edit and Show data to Modal
        getEditMateri: function (ref) {
            this.resetVarMateri(ref);
            $("#addMdlMateri").modal('show');
        },

        // Get Delete and Show Confirm Modal
        getDeleteMateri: function (ref) {
            this.resetVarMateri(ref);
            $("#delMdlMateri").modal('show');
        },
 
        // Delete Materi
        hapusMateri: function () {
            axios.post('api/subdtlmateridel', {
                    id_judul: this.subdtlmateri.id_judul
                })
                .then(res => {
                    // handle success
                    this.getAllMateri();
                    this.resetVarMateri(null);
                    $("#delMdlMateri").modal('hide');

                    let timerInterval
                    swal.fire({
                    title: 'Hapus Materi',
                    html: 'Materi berhasil dihapus!',
                    timer: 2000,
                    // icon: 'success',
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === swal.DismissReason.timer) {
                        console.log('I was closed by the timer')
                    }
                    })
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        //--------------------------
        // Get Materi
        getAll: function () {
            axios.get('api/materi')
                .then(res => {
                    // console.log(res.data);
                    this.lstmateri = res.data.data;
                    // this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // // Create New Materi
        // save: function () {
        //     axios.post('api/materi', {
        //             id_materi: this.materi.id_materi,
        //             nama_materi: this.materi.nama_materi
        //         })
        //         .then(res => {
        //             // handle success
        //             this.getAll();
        //             this.resetVar();
        //             $("#addMdl").modal('hide');
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // },

        // resetVar: function(ref){
        //     if(ref){
        //         this.materi.id_materi = ref.id_materi;
        //         this.materi.nama_materi = ref.nama_materi;
        //     } else {
        //         this.materi.id_materi = '';
        //         this.materi.nama_materi = '';
        //     }
        // },

        // // Get Edit and Show data to Modal
        // getEdit: function (ref) {
        //     resetVar(ref);
        //     $("#addMdl").modal('show');
        // },
 
        // // Get Delete and Show Confirm Modal
        // getDelete: function (ref) {
        //     resetVar(ref);
        //     $("#delMdl").modal('show');
        // },
 
        // // Delete Materi
        // hapus: function () {
        //     axios.post('api/materidel', {
        //             id_materi: this.materi.id_materi
        //         })
        //         .then(res => {
        //             // handle success
        //             this.getAll();
        //             this.resetVar();
        //             $("#delMdl").modal('hide');
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // },
        //--------------------------
        // Get sub_materi
        getAllSub: function () {
            axios.get('api/submateri')
                .then(res => {
                    // console.log(res.data);
                    this.lstsubmateri = res.data.data;
                    this.lstsubject = this.lstsubmateri;
                    // this.initDt("tblSub");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New sub_materi
        // saveSub: function () {
        //     axios.post('api/submateri', {
        //             id_sub_materi: this.submateri.id_sub_materi,
        //             id_materi: this.submateri.id_materi,
        //             nama_sub_materi: this.submateri.nama_sub_materi
        //         })
        //         .then(res => {
        //             // handle success
        //             this.getAllSub();
        //             this.resetVarSub();
        //             $("#addMdlSub").modal('hide');
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // },

        // resetVarSub: function(ref){
        //     if(ref){
        //         this.submateri.id_sub_materi = ref.id_sub_materi;
        //         this.submateri.id_materi = ref.id_materi;
        //         this.submateri.nama_sub_materi = ref.nama_sub_materi;
        //     } else {
        //         this.submateri.id_sub_materi = '';
        //         this.submateri.id_materi = '';
        //         this.submateri.nama_sub_materi = '';
        //     }
        // },

        // // Get Edit and Show data to Modal
        // getEditSub: function (ref) {
        //     resetVarSub(ref);
        //     $("#addMdlSub").modal('show');
        // },
 
        // // Get Delete and Show Confirm Modal
        // getDeleteSub: function (ref) {
        //     resetVarSub(ref);
        //     $("#delMdlSub").modal('show');
        // },
 
        // // Delete sub_materi
        // hapusSub: function () {
        //     axios.post('api/submateridel', {
        //             id_sub_materi: this.submateri.id_sub_materi
        //         })
        //         .then(res => {
        //             // handle success
        //             this.getAllSub();
        //             this.resetVarSub();
        //             $("#delMdlSub").modal('hide');
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Materi/index.vue